import React from "react";
import GenericPullAndPushToolView from "../GenericPullAndPushToolView";
import OligoCredentialsForm from "./OligoCredentialsForm";
import OligoConfigListing from "./OligoConfigListing";

const OligoPullAndPushView = (props) => (
  <GenericPullAndPushToolView
    {...props}
    PullCredentialForm={OligoCredentialsForm}
    PullConfigListingView={OligoConfigListing}
  />
);

export default OligoPullAndPushView;
